(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mega-menu"] && !Shopify.designMode) return;
  try {
    class MegaMenuWrapper extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.mega-menu__link[data-target]');
    this.panels = this.querySelectorAll('.mega-menu__panel');
  }

  connectedCallback() {
    this.setupEventListeners();
    this.initializeDefaultState();
  }

  setupEventListeners() {
    this.links.forEach(link => {
      // Only add hover listeners to links that have child content
      const targetId = link.getAttribute('data-target');
      const targetPanel = this.querySelector(`#${targetId}`);
      
      if (targetPanel && targetPanel.children.length > 0) {
        link.addEventListener('mouseenter', () => {
          this.handleLinkHover(link);
        });
      }
    });
  }

  initializeDefaultState() {
    // Set first panel as active by default
    if (this.panels.length > 0) {
      this.panels.forEach((panel, index) => {
        if (index === 0) {
          panel.dataset.active = 'true';
        } else {
          panel.dataset.active = 'false';
        }
      });
    }
  }

  handleLinkHover(link) {
    const targetId = link.getAttribute('data-target');
    const targetPanel = this.querySelector(`#${targetId}`);
    
    // Only proceed if target panel has content
    if (!targetPanel || targetPanel.children.length === 0) {
      return;
    }
    
    // Remove active state from all links
    this.links.forEach(l => {
      l.classList.remove('is-open');
    });
    
    // Add active state to current link
    link.classList.add('is-open');
    
    // Hide all panels
    this.panels.forEach(panel => {
      panel.dataset.active = 'false';
    });
    
    // Show target panel
    targetPanel.dataset.active = 'true';
  }
}

// Register the custom element
if (!customElements.get('mega-menu-wrapper')) {
  customElements.define('mega-menu-wrapper', MegaMenuWrapper);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_td-collection-custom-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-scroll-target]').forEach(element => {
      const target = document.querySelector(element.getAttribute('data-scroll-target'));
      if (target) {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          const absoluteTop = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: absoluteTop - 20,
            behavior: 'smooth'
          });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
